import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from "web-vitals";
import { captureEvent } from "@/lib/analytics";

/**
 * Reports Core Web Vitals (LCP, INP, CLS, FCP, TTFB) to GA4 so field
 * performance can be tracked alongside the conversion funnel (CRO §15: "Track
 * and improve Core Web Vitals alongside conversion rate").
 *
 * `value` is in ms for timing metrics and unitless for CLS; `rating` is
 * good/needs-improvement/poor.
 */
function report(metric: Metric) {
  captureEvent("web_vitals", {
    metric_name: metric.name,
    value: metric.value,
    rating: metric.rating,
    metric_delta: metric.delta,
    metric_id: metric.id,
    navigation_type: metric.navigationType,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
  });
}

export function initWebVitals() {
  if (typeof window === "undefined") return;
  onCLS(report);
  onINP(report);
  onLCP(report);
  onFCP(report);
  onTTFB(report);
}
